import React from 'react';

const CTA_BG = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('home cta.jpg')}`;

export default function HomeCta(): React.ReactElement {
  return (
    <section
      className="relative w-full overflow-hidden bg-slate-900"
      style={{
        backgroundImage: `url("${CTA_BG}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute inset-0 bg-slate-950/60" />

      <div className="relative mx-auto flex min-h-[85vh] w-full max-w-7xl items-center px-4 py-28 sm:px-6 sm:py-32 lg:px-12 lg:py-36">
        <div className="max-w-3xl text-left text-white">
          <h2 className="text-3xl font-semibold leading-tight sm:text-4xl">
            Ready to start your next project?
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/85 sm:text-lg">
            Talk to Ancient Engineering for multi-discipline solutions across Mining,
            Construction, and Manufacturing.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="/contact#contact-form"
              className="inline-flex w-full items-center justify-center rounded-md bg-white px-6 py-3 text-sm font-semibold text-slate-900 shadow-sm transition-colors hover:bg-white/90 sm:w-auto"
            >
              Get a Quote
            </a>
            <a
              href="/services"
              className="inline-flex w-full items-center justify-center rounded-md border border-white/60 bg-transparent px-6 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:border-white hover:bg-white/10 sm:w-auto"
            >
              Explore Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
